import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { round } from 'lodash';

import './InfoCard.scss';

const themes = ['red', 'blue', 'green', 'yellow'];

class DashboardCard extends React.PureComponent {
  handleRoute = ({ route, query }) => {
    const { onRoute } = this.props;
    onRoute({ route, query });
  };

  render() {
    const { theme, title, data, roundingPrecision, strings } = this.props;
    const roundNum = num => round(num, roundingPrecision);

    const rows = (
      <div className="rows">
        {data.map(({ value, label, route, query }, idx) => (
          <div
            className={cn('row', {
              large: data.length === 1,
              medium: data.length === 2,
              small: data.length >= 3,
            })}
            onClick={() => this.handleRoute({ route, query })}
            key={`${value}${strings[label] || label}${route}${idx}`} // eslint-disable-line react/no-array-index-key
            onKeyPress={() => this.handleRoute({ route, query })}
            role="link"
            tabIndex={0}
          >
            <span className={`value ${theme}`}>{roundNum(value)}</span>
            <span className="label">{strings[label] || label}</span>
          </div>
        ))}
      </div>
    );

    return (
      <div className={`dlpk value-card ${theme}`}>
        <div className="title">{title}</div>
        <div className={`core ${theme}`}>{rows}</div>
      </div>
    );
  }
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  theme: PropTypes.oneOf(themes),
  roundingPrecision: PropTypes.oneOf(['0', '1', '2']),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.const,
      route: PropTypes.string, // should be a route,
      query: PropTypes.string, // should be a query
    })
  ),
  onRoute: PropTypes.func,
};

DashboardCard.defaultProps = {
  theme: 'red',
  strings: {},
  data: [],
  roundingPrecision: '0',
  onRoute: val => {
    console.log('onRoute::', val); /* eslint-disable-line no-console */
  },
};
export default DashboardCard;
